import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import $ from 'jquery';

// CSS
import '../assets/css/navbar.css';

// Images
import Branding from '../assets/images/branding.png';

export default function Navbar() {
  // Sidebar Show Hide
  const [showSidebar, setShowSidebar] = useState(false);
  
  if(showSidebar){
    $(".main__nav .links").addClass("show");
    $(".main__nav .links").removeClass("hide");
  }
  else{
    $(".main__nav .links").removeClass("show");
    $(".main__nav .links").addClass("hide");
  }

  function setSidebarStatus(){
    setShowSidebar(!showSidebar)
  }

  return (
    <nav className="main__nav">
      <div className="container">
        <Link to='/' className="branding" onClick={() => {window.scrollTo(0, 0)}}>
          <img src={Branding} alt="HovSofts" />
        </Link>
        
        <ul className="links">
          <li><NavLink to="/" exact activeClassName="active" onClick={() => {window.scrollTo(0, 0)}}>Home</NavLink></li>
          <li><NavLink to="/services" exact activeClassName="active">Services</NavLink></li>
          <li><NavLink to="/about" exact activeClassName="active">About</NavLink></li>
          <li><NavLink to="/contact" exact activeClassName="active">Contact</NavLink></li>
        </ul>

        <div className={showSidebar? "sidebar_toggle animate" : "sidebar_toggle"} onClick={setSidebarStatus}><div></div></div>
      </div>
    </nav>
  )
}
